<template>
  <div class="body">
    <div class="title">
      活动详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"
            ><span class="dsadf"> 首页 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/huodongguanli' }"
            >活动管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px">
      <el-button size="mini" @click="$router.back()">返回</el-button>
    </div>

    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="活动信息" name="first">
          <div class="fromsss">
            <el-form
              ref="form"
              :model="addQuery"
              :rules="rules"
              label-width="120px"
              :label-position="labelPosition"
              @submit.native.prevent
            >
              <el-form-item
                label="内容形式"
                prop="enroll_switch"
                label-width="13%"
              >
                <el-radio-group
                  v-model="addQuery.enroll_switch"
                  :disabled="tempUpdateFlag"
                >
                  <el-radio label="0">活动信息</el-radio>
                  <el-radio label="1">活动报名</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="活动名称" prop="name" label-width="13%">
                <el-input
                  v-model="addQuery.name"
                  style="width: 400px"
                  placeholder="请输入活动名称"
                ></el-input>
              </el-form-item>

              <el-form-item label="方式" prop="type" label-width="13%">
                <el-radio-group
                  v-model="addQuery.type"
                  :disabled="tempUpdateFlag"
                >
                  <el-radio label="1">赛事</el-radio>
                  <el-radio label="2">党建</el-radio>
                  <el-radio label="3">培训</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="项目" prop="sport_type" label-width="13%">
                <!-- <el-select :multiple="true" :multiple-limit="1" style="width: 400px;" v-model="addQuery.sport_type" placeholder="选择活动类型" :disabled="addQuery.is_status !== 0">
                  <el-option v-for="item in sportTypes" :key="item.value" :label="item.label" :value="item.value" />
                </el-select> -->
                <el-checkbox-group
                  v-model="addQuery.sport_type"
                  :disabled="tempUpdateFlag"
                >
                  <el-checkbox
                    v-for="item in sportTypes"
                    :label="item.value"
                    :key="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
              <!-- <el-form-item label="活动场地" prop="site_type" label-width="13%">
                <el-select v-model="value1" multiple placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              </el-form-item> -->

              <el-form-item
                v-if="addQuery.enroll_switch == 1"
                label="活动分组"
                prop="act_group_ids"
                label-width="13%"
              >
                <div>
                  <el-radio-group
                    v-model="addQuery.group_switch"
                    :disabled="groupFlag"
                  >
                    <el-radio label="0">不设分组</el-radio>
                    <el-radio label="1">自定义分组</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="addQuery.group_switch == 1">
                  <el-input
                    v-model="activeGroupForm.name"
                    size="small"
                    placeholder="组名"
                    style="width: 150px; margin-right: 10px"
                    :disabled="groupFlag"
                  >
                  </el-input>
                  <el-input
                    v-model="activeGroupForm.number"
                    size="small"
                    placeholder="人数"
                    style="width: 80px; margin-right: 10px"
                    :disabled="groupFlag"
                  >
                  </el-input>
                  <!-- <el-input v-model="activeGroupForm.age" size="small" placeholder="年龄"
                    style="width: 80px; margin-right: 10px">
                  </el-input> -->
                  <el-date-picker
                    :disabled="groupFlag"
                    v-model="activeGroupForm.ageStart"
                    size="small"
                    type="year"
                    value-format="yyyy"
                    placeholder="最小年龄"
                    :picker-options="pickerOptionsAge"
                    style="width: 120px; margin-right: 10px"
                  >
                  </el-date-picker>
                  <el-date-picker
                    :disabled="groupFlag"
                    v-model="activeGroupForm.ageEnd"
                    size="small"
                    type="year"
                    value-format="yyyy"
                    placeholder="最大年龄"
                    :picker-options="pickerOptionsAge"
                    style="width: 120px; margin-right: 10px"
                  >
                  </el-date-picker>
                  <!-- <el-input v-model="activeGroupForm.sex" size="small" placeholder="性别"
                    style="width: 80px; margin-right: 10px">
                  </el-input> -->
                  <el-select
                    :disabled="groupFlag"
                    v-model="activeGroupForm.sex"
                    size="small"
                    placeholder="性别"
                    style="width: 100px; margin-right: 10px"
                  >
                    <el-option
                      v-for="item in sexList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-button
                    :disabled="groupFlag"
                    size="small"
                    @click="addGroup"
                    style="width: 80px"
                    >添加</el-button
                  >
                  <div>
                    <el-tag
                      :key="tag.id"
                      v-for="(tag, index) in activeGroup"
                      :closable="!groupFlag"
                      :disable-transitions="false"
                      style="margin: 10px 10px 0 0"
                      @close="deleteGroup(tag, index)"
                    >
                      {{ tag.title }}
                    </el-tag>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="宣传图片" prop="pics" label-width="13%">
                <div class="from">
                  <div
                    class="imgbox"
                    v-for="(item, index) in pics"
                    :key="index"
                  >
                    <img :src="item.name" alt="" class="imgs" />
                    <img
                      src="../../assets/img/shanchu.png"
                      mode=""
                      class="close"
                      @click="closeImgs(index)"
                      v-if="item"
                    />
                  </div>
                </div>
                <el-upload
                  ref="upload"
                  action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic"
                  :on-progress="progress"
                  :on-success="handleAvatarSuccess"
                  :limit="9"
                  :before-upload="$beforeUploadImage"
                  :on-exceed="handleExceed"
                  list-type="picture"
                  :data="{ token: token }"
                  name="pic"
                >
                  <el-button size="small" type="primary">选择</el-button>
                </el-upload>
              </el-form-item>

              <el-form-item label="介绍" prop="introduce" label-width="13%">
                <quill-editor
                  class="appwrapper"
                  v-model="addQuery.introduce"
                  :rows="3"
                  ref="myQuillEditor"
                  :options="editorOption"
                  style="width: 50%"
                >
                </quill-editor>
              </el-form-item>

              <el-form-item label="总结" label-width="13%">
                <quill-editor
                  class="appwrapper"
                  v-model="addQuery.summarize"
                  :rows="3"
                  ref="myQuillEditor2"
                  :options="editorOption2"
                  style="width: 50%"
                >
                </quill-editor>
              </el-form-item>

              <el-form-item
                v-if="addQuery.enroll_switch == 1"
                label="报名时间"
                prop="enroll_starttime"
                label-width="13%"
                :disabled="tempUpdateFlag"
              >
                <el-date-picker
                  v-model="enrolltime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  @change="changeEnrolltime"
                  :disabled="tempUpdateFlag"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="活动时间"
                prop="act_starttime"
                label-width="13%"
              >
                <el-date-picker
                  v-model="acttime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  @change="changeActtime"
                  :disabled="tempUpdateFlag"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="地址"
                prop="address"
                label-width="13%"
                @click.native="
                  GetJWD(
                    'address',
                    addQuery.signin_distance,
                    addQuery.address,
                    addQuery.longitude,
                    addQuery.latitude
                  )
                "
              >
                <!-- longitude longitude -->
                <el-input
                  v-model="addQuery.address"
                  prefix-icon="el-icon-location"
                  readonly
                  placeholder="请选择"
                  style="width: 400px"
                  :disabled="tempUpdateFlag"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="活动地址" prop="area_id" label-width="13%">
                                <el-cascader v-model="areaArray" :props="checkedData.typeOptions" @change="changList"></el-cascader>
                            </el-form-item>
                            <el-form-item label="" prop="address" label-width="13%">
                                <el-input v-model="addQuery.address" style="width: 400px;" placeholder="请输入详细地址"></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="longitude" label-width="13%">
                                <el-row style="margin-bottom: 10px">
                                    <vxe-button size="medium" content="获取活动位置经纬度" status="primary" @click="GetJWD('address')"></vxe-button>
                                </el-row>
                                <el-row style="margin-bottom: 10px">
                                    <el-input v-model="addQuery.longitude" style="width: 500px" placeholder="请选择经度" disabled></el-input>
                                </el-row>
                                <el-row>
                                    <el-input v-model="addQuery.latitude" style="width: 500px" placeholder="请选择纬度" disabled></el-input>
                                </el-row>
                            </el-form-item> -->

              <!-- 活动报名 -->
              <template v-if="addQuery.enroll_switch == 1">
                <!-- 签到 -->
                <el-form-item label="活动签到" label-width="13%">
                  <el-radio
                    v-model="isNotSignin"
                    :label="true"
                    @input="inputIsNotSignin"
                    :disabled="tempUpdateFlag"
                    >无需签到</el-radio
                  >
                  <el-radio
                    v-for="(item, index) in signInList"
                    :key="item.value"
                    v-model="addQuery.signin_type[index]"
                    :label="item.value"
                    @click.native.prevent="clickSigninType(index)"
                    :disabled="tempUpdateFlag"
                    >{{ item.label }}</el-radio
                  >
                </el-form-item>
                <!-- <el-form-item label="是否需要签到" label-width="13%">
                                  <el-switch v-model="isSignin" active-text="是" inactive-text="否">
                                  </el-switch>
                              </el-form-item> -->

                <template v-if="!isNotSignin">
                  <el-form-item
                    label="签到时间"
                    prop="signin_starttime"
                    label-width="13%"
                  >
                    <el-date-picker
                      v-model="signintime"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm"
                      @change="changeSignintime"
                      :disabled="tempUpdateFlag"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <!-- <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到位置" prop="signin_address"
                    label-width="13%" @click.native="GetJWD('qiandao', addQuery.signin_distance, addQuery.signin_address, addQuery.signin_lng, addQuery.signin_lat)"> -->
                  <el-form-item
                    v-if="addQuery.signin_type.indexOf('1') > -1"
                    label="签到位置"
                    prop="signin_address"
                    label-width="13%"
                  >
                    <el-input
                      disabled
                      v-model="addQuery.address"
                      prefix-icon="el-icon-location"
                      readonly
                      placeholder="请选择"
                      style="width: 400px"
                    ></el-input>
                  </el-form-item>
                  <!-- signin_lng signin_lat -->

                  <!-- <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到范围" prop="signin_distance"
                    label-width="13%" @click.native="GetJWD('qiandao', addQuery.signin_distance, addQuery.signin_address, addQuery.signin_lng, addQuery.signin_lat)"> -->
                  <el-form-item
                    v-if="addQuery.signin_type.indexOf('1') > -1"
                    label="签到范围"
                    prop="signin_distance"
                    label-width="13%"
                  >
                    <el-input
                      disabled
                      v-model="addQuery.signin_distance"
                      readonly
                      placeholder="请选择"
                      style="width: 200px"
                    ></el-input>
                    <span style="color: #999">米</span>
                  </el-form-item>

                  <!-- <el-form-item label="签到方式" prop="signin_type" label-width="13%">
                                      <el-select v-model="addQuery.signin_type" multiple placeholder="请选择" style="width: 400px;">
                                          <el-option v-for="item in signInList" :key="item.value" :label="item.label" :value="item.value" />
                                      </el-select>
                                  </el-form-item>

                                  <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到地点" prop="signin_address" label-width="13%">
                                      <el-input v-model="addQuery.signin_address" style="width: 400px;" placeholder="请输入详细地址"></el-input>
                                  </el-form-item>
                                  <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="" prop="signin_lng" label-width="13%">
                                      <el-row style="margin-bottom: 10px">
                                          <vxe-button size="medium" content="获取签到地址经纬度" status="primary" @click="GetJWD('qiandao')"></vxe-button>
                                      </el-row>
                                      <el-row style="margin-bottom: 10px">
                                          <el-input v-model="addQuery.signin_lng" style="width: 400px;" placeholder="请选择经度" disabled></el-input>
                                      </el-row>
                                      <el-row>
                                          <el-input v-model="addQuery.signin_lat" style="width: 400px;" placeholder="请选择纬度" disabled></el-input>
                                      </el-row>
                                  </el-form-item>

                                  <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到范围" prop="signin_distance" label-width="13%">
                                      <el-select v-model="addQuery.signin_distance" placeholder="请选择" style="width: 400px;">
                                          <el-option v-for="item in signInMiList" :key="item.value" :label="item.label" :value="item.value" />
                                      </el-select>
                                  </el-form-item> -->

                  <!-- <el-form-item v-if="addQuery.signin_type.indexOf('2') > -1" label="签到二维码" prop="signin_qrcode" label-width="13%">
                                      <div class="from">
                                          <div v-if="addQuery.signin_qrcode" class="imgbox">
                                              <img :src="addQuery.signin_qrcode" alt="" class="imgs" />
                                              <img src="../../assets/img/shanchu.png" mode="" class="close" @click="addQuery.signin_qrcode = ''" />
                                          </div>
                                      </div>
                                      <el-upload v-if="!addQuery.signin_qrcode" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="onSuccessSignin_qrcode" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                                          <el-button size="small" type="primary">选择</el-button>
                                      </el-upload>
                                  </el-form-item> -->

                  <el-form-item
                    label=" "
                    label-width="13%"
                    v-if="addQuery.signin_type.indexOf('1') > -1"
                  >
                    <el-button
                      type="primary"
                      size="small"
                      :disabled="tempUpdateFlag"
                      @click.native="
                        GetJWD(
                          'qiandao',
                          addQuery.signin_distance,
                          addQuery.signin_address,
                          addQuery.signin_lng,
                          addQuery.signin_lat
                        )
                      "
                      >修改签到信息</el-button
                    >
                  </el-form-item>
                </template>

                <!-- 签退 -->
                <el-form-item label="活动签退" label-width="13%">
                  <el-radio
                    v-model="isNotSignout"
                    :label="true"
                    @input="inputIsNotSignout"
                    :disabled="tempUpdateFlag"
                    >无需签退</el-radio
                  >
                  <el-radio
                    v-for="(item, index) in signOutList"
                    :key="item.value"
                    v-model="addQuery.signout_type[index]"
                    :label="item.value"
                    @click.native.prevent="clickSignoutType(index)"
                    :disabled="tempUpdateFlag"
                    >{{ item.label }}</el-radio
                  >
                </el-form-item>
                <!-- <el-form-item label="是否需要签退" label-width="13%">
                                  <el-switch v-model="isSignout" active-text="是" inactive-text="否">
                                  </el-switch>
                              </el-form-item> -->

                <template v-if="!isNotSignout">
                  <el-form-item
                    label="签退时间"
                    prop="signout_starttime"
                    label-width="13%"
                  >
                    <el-date-picker
                      v-model="signouttime"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      :disabled="tempUpdateFlag"
                      end-placeholder="结束时间"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm"
                      @change="changeSignouttime"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item
                    v-if="addQuery.signout_type.indexOf('1') > -1"
                    label="签退位置"
                    prop="signout_address"
                    label-width="13%"
                    @click.native="
                      GetJWD(
                        'qiantui',
                        addQuery.signout_distance,
                        addQuery.signout_address,
                        addQuery.signout_lng,
                        addQuery.signout_lat
                      )
                    "
                  >
                    <!-- signout_lng signout_lat -->
                    <el-input
                      v-model="addQuery.signout_address"
                      prefix-icon="el-icon-location"
                      readonly
                      placeholder="请选择"
                      :disabled="tempUpdateFlag"
                      style="width: 400px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="addQuery.signout_type.indexOf('1') > -1"
                    label="签退范围"
                    prop="signout_distance"
                    label-width="13%"
                    @click.native="
                      GetJWD(
                        'qiantui',
                        addQuery.signout_distance,
                        addQuery.signout_address,
                        addQuery.signout_lng,
                        addQuery.signout_lat
                      )
                    "
                  >
                    <el-input
                      v-model="addQuery.signout_distance"
                      readonly
                      placeholder="请选择"
                      :disabled="tempUpdateFlag"
                      style="width: 200px"
                    ></el-input>
                    <span style="color: #999">米</span>
                  </el-form-item>

                  <!-- <el-form-item label="签退方式" prop="signout_type" label-width="13%">
                                      <el-select v-model="addQuery.signout_type" multiple placeholder="请选择" style="width: 400px;">
                                          <el-option v-for="item in signOutList" :key="item.value" :label="item.label" :value="item.value" />
                                      </el-select>
                                  </el-form-item>

                                  <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退地点" prop="signout_address" label-width="13%">
                                      <el-input v-model="addQuery.signout_address" style="width: 400px;" placeholder="请输入详细地址"></el-input>
                                  </el-form-item>
                                  <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="" prop="signout_lng" label-width="13%">
                                      <el-row style="margin-bottom: 10px">
                                          <vxe-button size="medium" content="获取签退地址经纬度" status="primary" @click="GetJWD('qiantui')"></vxe-button>
                                      </el-row>
                                      <el-row style="margin-bottom: 10px">
                                          <el-input v-model="addQuery.signout_lng" style="width: 400px;" placeholder="请选择经度" disabled></el-input>
                                      </el-row>
                                      <el-row>
                                          <el-input v-model="addQuery.signout_lat" style="width: 400px;" placeholder="请选择纬度" disabled></el-input>
                                      </el-row>
                                  </el-form-item>

                                  <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退距离" prop="signout_distance" label-width="13%">
                                      <el-select v-model="addQuery.signout_distance" placeholder="请选择" style="width: 400px;">
                                          <el-option v-for="item in signOutMiList" :key="item.value" :label="item.label" :value="item.value" />
                                      </el-select>
                                  </el-form-item> -->

                  <!-- <el-form-item v-if="addQuery.signout_type.indexOf('2') > -1" label="签退二维码" prop="signout_qrcode" label-width="13%">
                                      <div class="from">
                                          <div v-if="addQuery.signout_qrcode" class="imgbox">
                                              <img :src="addQuery.signout_qrcode" alt="" class="imgs" />
                                              <img src="../../assets/img/shanchu.png" mode="" class="close" @click="addQuery.signout_qrcode = ''" />
                                          </div>
                                      </div>
                                      <el-upload v-if="!addQuery.signout_qrcode" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="onSuccessSignout_qrcode" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                                          <el-button size="small" type="primary">选择</el-button>
                                      </el-upload>
                                  </el-form-item> -->

                  <el-form-item
                    label=" "
                    label-width="13%"
                    v-if="addQuery.signout_type.indexOf('1') > -1"
                  >
                    <el-button
                      type="primary"
                      size="small"
                      :disabled="tempUpdateFlag"
                      @click.native="
                        GetJWD(
                          'qiantui',
                          addQuery.signout_distance,
                          addQuery.signout_address,
                          addQuery.signout_lng,
                          addQuery.signout_lat
                        )
                      "
                      >修改签退信息</el-button
                    >
                  </el-form-item>
                </template>

                <!-- <el-form-item label="活动路线图" prop="road_map" label-width="13%">
                                  <el-input v-model="addQuery.road_map" type="textarea" style="width: 294px" placeholder="请输入活动路线图"></el-input>
                              </el-form-item> -->

                <el-form-item
                  label="直播地址"
                  prop="live_link"
                  label-width="13%"
                >
                  <div>
                    <el-radio-group v-model="addQuery.live_switch">
                      <el-radio label="0">无直播</el-radio>
                      <el-radio label="1">有直播</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-if="addQuery.live_switch == 1">
                    <el-radio-group v-model="addQuery.live_type">
                      <el-radio label="1">视频</el-radio>
                      <el-radio label="2">图文</el-radio>
                    </el-radio-group>
                  </div>
                  <el-input
                    v-if="addQuery.live_switch == 1"
                    v-model="addQuery.live_link"
                    placeholder="请输入直播地址"
                    style="width: 400px"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="支付地址"
                  prop="pay_link"
                  label-width="13%"
                >
                  <div>
                    <el-radio-group
                      v-model="addQuery.pay_switch"
                      :disabled="tempUpdateFlag"
                    >
                      <el-radio label="0">无支付</el-radio>
                      <el-radio label="1">有支付</el-radio>
                    </el-radio-group>
                  </div>
                  <el-input
                    v-if="addQuery.pay_switch == 1"
                    v-model="addQuery.pay_link"
                    placeholder="请输入支付地址"
                    style="width: 400px"
                    :disabled="tempUpdateFlag"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  v-if="addQuery.group_switch == 0"
                  label="报名人数上限"
                  prop="enroll_limit"
                  label-width="13%"
                >
                  <el-input-number
                    v-model="addQuery.enroll_limit"
                    placeholder="请输入报名人数"
                    :disabled="tempUpdateFlag"
                  ></el-input-number>
                  人
                </el-form-item>
                <el-form-item
                  v-if="addQuery.enroll_switch == 1"
                  label="报名是否需要审核"
                  prop="enroll_status"
                  label-width="13%"
                >
                  <el-radio-group v-model="addQuery.enroll_status">
                    <el-radio label="1">需要审核</el-radio>
                    <el-radio label="2">无需审核</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>

              <!-- <el-form-item label="报名金额" label-width="13%">
                <el-input
                  v-model="addQuery.enroll_fee"
                  style="width: 294px"
                  placeholder="请输入报名金额"
                ></el-input
                >元
              </el-form-item>
              <el-form-item label="活动赞助" label-width="13%">
                <div class="formClass">
                  <div
                    v-for="(item, index) in addQuery.act_sponsor"
                    :key="index"
                    style="margin-bottom: 10px"
                  >
                    <el-input
                      v-model="item.name"
                      style="width: 294px"
                      placeholder="请输入赞助商"
                    ></el-input>
                    <el-input
                      v-model="item.content"
                      style="width: 294px"
                      placeholder="请输入赞助内容"
                    ></el-input>
                    <span @click="deletecc(index)" class="addzanzu ml"
                      >删除</span
                    >
                  </div>
                </div>
                <div class="addzanzu" @click="addzanzucc">增加新赞助</div>
              </el-form-item> -->
            </el-form>
            <!-- v-if="addQuery.is_status === 1 || addQuery.is_status === 0" -->
            <el-button type="primary" @click="xiugaihuodong">保存</el-button>
            <el-button v-if="addQuery.is_status === 0" @click="caogao"
              >保存为草稿</el-button
            >

            <div class="block-none">
              <el-upload
                class="avatar-uploader1"
                ref="upload_1"
                :action="
                  editorImgOrVideo === 'img'
                    ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
                    : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
                "
                :on-progress="progress"
                :on-success="uploadSuccess"
                :limit="1"
                :before-upload="
                  editorImgOrVideo === 'img'
                    ? $beforeUploadImage
                    : $beforeUploadVideo
                "
                :on-exceed="handleExceed"
                list-type="picture"
                :data="{ token: token }"
                :name="editorImgOrVideo === 'img' ? 'pic' : 'video'"
                :shrow-file-list="false"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
            <div class="block-none">
              <el-upload
                class="avatar-uploader2"
                ref="upload_2"
                :action="
                  editorImgOrVideo2 === 'img'
                    ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
                    : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
                "
                :on-progress="progress"
                :on-success="uploadSuccess2"
                :limit="1"
                :before-upload="
                  editorImgOrVideo2 === 'img'
                    ? $beforeUploadImage
                    : $beforeUploadVideo
                "
                :on-exceed="handleExceed"
                list-type="picture"
                :data="{ token: token }"
                :name="editorImgOrVideo2 === 'img' ? 'pic' : 'video'"
                :shrow-file-list="false"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="false" label="活动嘉宾" name="second">
          <div class="boxssdff">
            <!--           <div class="addss">-->
            <!--             <el-button type="primary" @click="openAdd">-->
            <!--               <i class="el-icon-plus"></i>-->
            <!--               添加</el-button>-->
            <!--           </div>-->
            <div style="flex: 1"></div>
            <el-input
              placeholder="请输入内容"
              style="width: 336px"
              @input="Discountsearchcc"
              v-model="huodongQuery.keyword"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <vxe-table
            border
            show-overflow
            keep-source
            ref="xTable"
            max-height="400"
            align="center"
            :data="huodongtableData"
          >
            <vxe-table-column
              field="realname"
              title="姓名"
              width="100"
            ></vxe-table-column>
            <vxe-table-column title="头像" width="200">
              <template slot-scope="scope">
                <img :src="scope.row.facepic" alt="" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="mobile"
              title="手机号码"
              width="150"
            ></vxe-table-column>
            <vxe-table-column
              field="pay_types"
              title="支付方式"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="pay_money"
              title="支付金额"
              width="250"
            ></vxe-table-column>
            <vxe-table-column
              field="pay_time"
              title="支付时间"
              width="250"
            ></vxe-table-column>
            <vxe-table-column
              field="order_no"
              title="订单号"
              width="500"
            ></vxe-table-column>
          </vxe-table>
          <div v-if="pageshowcc">
            <el-pagination
              @size-change="handleSizeChangecc"
              @current-change="handleCurrentChangecc"
              :current-page="cur_page"
              :page-sizes="[10, 15, 20]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="huodongTotal"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="活动图片" name="third">
          <el-form style="margin-top: 60px" label-width="80px" :label-position="labelPosition">
            <el-form-item label="比赛图片" label-width="13%">
              <div class="from">
                <div class="imgbox" v-for="(item, index) in huiguQuery.review" :key="index">
                  <img :src="item.name" alt="" class="imgs" />
                  <img src="../../assets/img/shanchu.png" mode="" class="close" @click="closeImgsreview(index)"
                    v-if="item" />
                </div>
              </div>
              <el-upload v-if="huiguQuery.review.length !== 9" class="upload-demo" ref="upload"
                action="/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatar" :limit="9"
                :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }"
                name="pic">
                <el-button size="small" type="primary">选择</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="tijiaohuigu">提交</el-button>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <vxe-modal
      v-model="showDetails"
      title="选择用户"
      width="1000"
      height="400"
      :mask="false"
      :lock-view="false"
      resize
    >
      <template #default>
        <div class="hearder">
          <div class="left">
            <el-form :inline="true">
              <el-form-item>
                <el-select
                  placeholder="排序"
                  style="min-width: 168px; width: 168px"
                  clearable
                >
                  <el-option
                    name="selected"
                    :value="0"
                    label="发布时间倒序 "
                  ></el-option>
                  <el-option
                    name="selected"
                    :value="1"
                    label="活动时间倒序 "
                  ></el-option>
                  <el-option
                    name="selected"
                    :value="2"
                    label="报名人数多优先 "
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select
                  placeholder="会员状态"
                  style="min-width: 168px; width: 168px"
                  clearable
                >
                  <el-option
                    name="selected"
                    :value="1"
                    label="全部 "
                  ></el-option>
                  <el-option
                    name="selected"
                    :value="0"
                    label="室内 "
                  ></el-option>
                  <el-option
                    name="selected"
                    :value="0"
                    label="室外 "
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <el-form :inline="true">
            <el-form-item>
              <el-input
                placeholder="排序/跳转链接/链接说明 "
                style="min-width: 168px; width: 336px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          :data="userform"
          ref="EditUsertable"
          @selection-change="EdithandleSelectionChange"
          :row-key="(row) => row.user_id"
        >
          <el-table-column type="selection" :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="user_id" label="用户ID"> </el-table-column>
          <el-table-column prop="nick_name" label="用户昵称"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="pho" label="头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.head_pic"
                min-width="70"
                height="70"
                :onerror="defaultImg"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>
    </vxe-modal>
    <vxe-modal
      width="1000"
      ref="fabuzhe"
      height="800"
      size="small"
      :show-footer="false"
      title="请选择发布者"
      :show-close="true"
    >
      <el-card>
        <el-form :inline="true">
          <el-form-item>
            <el-input
              v-model="Querycc.keyword"
              @input="Discountsearch"
              placeholder="请输入关键词"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-table
        :data="xiehuiArr"
        ref="multipleTable"
        @selection-change="EdithandleSelectionChange"
        @select="select"
        @select-all="selectAll"
        :row-key="(row) => row.user_id"
      >
        <el-table-column type="selection" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="org_com" label="名称"> </el-table-column>
        <el-table-column prop="pho" label="logo">
          <template slot-scope="scope">
            <img :src="scope.row.org_logo" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{ scope.row.types === 1 ? "商会" : "协会" }}
          </template>
        </el-table-column>
      </el-table>
      <div v-if="pageshow">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="cur_page"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="xiehuiTotal"
        >
        </el-pagination>
      </div>
      <div style="margin-top: 200px">
        <el-button type="primary" @click="cclose">确认</el-button>
      </div>
    </vxe-modal>

    <Amap ref="AmapCom" @onAddrConfirm="AddrConfirm" />
  </div>
</template>

<script>
import { area, city, province, getWzArea } from "@/api/city";
import {
  getBusinessSportTypeList,
  getBusinessSportSiteList,
} from "@/api/shangxiehui";

import {
  getActiveGroup,
  addActiveGroup,
  editActiveGroup,
  delActiveGroup,
} from "@/api/huodongfenzu";
import {
  actBusinessassociationlist,
  actEnrolllist,
  actReview,
  actSubmitreview,
  actUpdate,
  actview,
} from "@/api/tiezi";
import Amap from "../../components/Amap";
import waves from "../../directive/waves";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];
import { mapState } from "vuex";
export default {
  computed: {
    // ...mapState(["huodongID"]),
  },
  name: "huodongguanlichakanxiangqing",
  directives: { waves },
  components: { Amap },
  data() {
    const checkActTime = (rule, value, callback) => {
      let enroll_starttime = this.addQuery.enroll_starttime;
      let enroll_endtime = this.addQuery.enroll_endtime;
      let act_starttime = this.addQuery.act_starttime;
      let act_endtime = this.addQuery.act_endtime;

      if (enroll_starttime && enroll_endtime && act_starttime && act_endtime) {
        enroll_starttime = new Date(
          enroll_starttime.replace(/-/g, "/")
        ).getTime();
        enroll_endtime = new Date(enroll_endtime.replace(/-/g, "/")).getTime();
        act_starttime = new Date(act_starttime.replace(/-/g, "/")).getTime();
        act_endtime = new Date(act_endtime.replace(/-/g, "/")).getTime();

        if (enroll_starttime >= enroll_endtime) {
          callback(new Error("报名开始时间 必须早于 报名结束时间"));
        } else if (enroll_starttime > act_starttime) {
          callback(new Error("活动开始时间 不得早于 报名开始时间"));
        } else if (act_starttime >= act_endtime) {
          callback(new Error("活动开始时间 必须早于 活动结束时间"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return {
      tempUpdateFlag: false, // 更新限制标识
      groupFlag: false, //  组别标志
      sportTypes: [],
      siteTypes: [],
      areaArray: [],

      areaList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now();
        },
      },
      endDatePickercc: this.processDatecc(),
      endDatePicker: this.processDate(),
      huiguQuery: {
        review: [],
      },
      token: sessionStorage.getItem("token"),
      cur_page: 1,
      typeList: [
        {
          label: "跑步",
          value: "1",
        },
        {
          label: "篮球",
          value: "2",
        },
        {
          label: "羽毛球",
          value: "3",
        },
        {
          label: "乒乓球",
          value: "4",
        },
        {
          label: "足球",
          value: "5",
        },
        {
          label: "游泳",
          value: "6",
        },
        {
          label: "篮球",
          value: "7",
        },
        {
          label: "党建活动",
          value: "10",
        },
        {
          label: "马拉松",
          value: "11",
        },
        {
          label: "其他",
          value: "8",
        },
      ],
      startDatePicker: this.beginDate(),
      pageshow: true,
      xiehuiArr: [],
      xiehuiTotal: null,
      xiehuiQuery: {
        org_com: "",
      },
      Querycc: {
        token: sessionStorage.getItem("token"),
        keyword: "",
        page: 1,
        pagesize: 10,
      },
      pics: [],
      name: "",
      showMap: false,
      mapShowType: "address",
      signAddress: "",
      enrolltime: [],
      acttime: [],
      signintime: [],
      signouttime: [],
      addQuery: {
        enroll_switch: "0",
        name: "",
        type: "1",
        pics: [],
        token: sessionStorage.getItem("token"),
        user_id: "",
        space: "",
        introduce: "",
        province_id: "",
        city_id: "",
        area_id: "",
        town_id: "",
        address: "",
        act_starttime: "",
        act_endtime: "",
        enroll_starttime: "",
        enroll_endtime: "",
        enroll_limit: "999",
        enroll_fee: "",
        act_sponsor: [],
        longitude: "",
        latitude: "",

        group_switch: "0",
        act_group_ids: [],

        signin_type: ["", "", ""],
        signin_starttime: "",
        signin_endtime: "",
        signin_address: "",
        signin_lng: "",
        signin_lat: "",
        signin_distance: 0,
        signin_qrcode: "",

        signout_type: ["", "", ""],
        signout_starttime: "",
        signout_endtime: "",
        signout_address: "",
        signout_lng: "",
        signout_lat: "",
        signout_distance: 0,
        signout_qrcode: "",

        road_map: "",
        live_switch: "0",
        live_type: "1",
        live_link: "",
        pay_switch: "0",
        pay_link: "",
      },
      rules: {
        enroll_switch: [{ required: true, message: "请选择", trigger: "blur" }],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        type: [{ required: true, message: "请选择", trigger: "blur" }],
        space: [{ required: true, message: "请选择", trigger: "blur" }],
        // act_group_ids: [{ required: true, type: 'array', message: '请添加', trigger: 'blur' }],
        // pics: [
        //   { required: true, type: "array", message: "请上传", trigger: "blur" },
        // ],
        introduce: [{ required: true, message: "请输入", trigger: "blur" }],
        // area_id: [{ required: true, message: "请选择", trigger: "blur" }],
        address: [{ required: true, message: "请选择", trigger: "blur" }],
        longitude: [{ required: true, message: "请选择", trigger: "blur" }],
        act_starttime: [
          { required: true, message: "请选择", trigger: "blur" },
          { validator: checkActTime, trigger: "blur" },
        ],
        act_endtime: [
          { required: true, message: "请选择", trigger: "blur" },
          { validator: checkActTime, trigger: "blur" },
        ],
        enroll_starttime: [
          { required: true, message: "请选择", trigger: "blur" },
          { validator: checkActTime, trigger: "blur" },
        ],
        enroll_endtime: [
          { required: true, message: "请选择", trigger: "blur" },
          { validator: checkActTime, trigger: "blur" },
        ],

        // signin_type: [
        //     { required: true, type: "array", message: "请选择", trigger: "blur" },
        // ],
        signin_starttime: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        // signin_address: [
        //     { required: true, message: "请选择", trigger: "blur" },
        // ],
        // signin_lng: [
        //     { required: true, message: "请选择", trigger: "blur" },
        // ],
        signin_distance: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        // signin_qrcode: [
        //     { required: true, message: "请上传", trigger: "blur" },
        // ],

        signout_starttime: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        signout_address: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        // signout_lng: [
        //     { required: true, message: "请选择", trigger: "blur" },
        // ],
        signout_distance: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        // signout_qrcode: [
        //     { required: true, message: "请上传", trigger: "blur" },
        // ],

        enroll_limit: [{ required: true, message: "请输入", trigger: "blur" }],
        site_type: [{ required: true, message: "请选择", trigger: "blur" }],
        sport_type: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  this.editorImgOrVideo = "img";
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  this.editorImgOrVideo = "video";
                  // 触发input框选择视频文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
      },
      editorImgOrVideo: "img",
      editorOption2: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  this.editorImgOrVideo2 = "img";
                  // debugger;
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader2 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  this.editorImgOrVideo2 = "video";
                  // debugger;
                  // 触发input框选择视频文件
                  document.querySelector(".avatar-uploader2 input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
      },
      editorImgOrVideo2: "img",
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad,
        },
      },
      formddart: {},
      userform: [],
      NewArr: [],
      array: [],
      tableData: [
        {
          bankuai: "ss",
          biaoti: "ss",
          tiezi: "ss",
          fabuzhe: "ssaa",
          dianhua: "ssca",
          shijian: "sasaa",
          liulanqi: "sasa",
          fabuzhuangtai: "saddas",
          zhiding: "sadads",
        },
      ],
      showDetails: false,
      activeName: "first",
      labelPosition: "left",
      form: {
        zanzu: [
          {
            zanzhushang: "",
            zanzuwuzhi: "",
          },
        ],
      },

      value: "",
      shengshiqu: [],
      huodongQuery: {
        keyword: "",
        page: 10,
        pagesize: 10,
      },
      huodongTotal: null,
      huodongtableData: [],
      pageshowcc: true,
      huodongcur_page: 1,

      // 活动分组
      pickerOptionsAge: {
        disabledDate(time) {
          const nowYear = new Date().getFullYear();
          return nowYear - time.getFullYear() < 6;
        },
      },
      activeGroupForm: {
        name: "",
        number: "",
        ageStart: "",
        ageEnd: "",
        age: "",
        sex: "不限",
      },
      activeGroup: [],
      sexList: [
        {
          label: "不限",
          value: "不限",
        },
        {
          label: "男",
          value: "男",
        },
        {
          label: "女",
          value: "女",
        },
      ],

      isSignin: false,
      isNotSignin: true,
      signinType: ["", "", ""],
      signInList: [
        {
          label: "定位签到",
          value: "1",
        },
        {
          label: "扫码签到",
          value: "2",
        },
        {
          label: "亮码签到",
          value: "3",
        },
      ],
      signInMiList: [
        {
          label: "100米",
          value: 100,
        },
        {
          label: "500米",
          value: 500,
        },
      ],

      isSignout: false,
      isNotSignout: true,
      signoutType: ["", "", ""],
      signOutList: [
        {
          label: "定位签退",
          value: "1",
        },
        {
          label: "扫码签退",
          value: "2",
        },
        {
          label: "亮码签退",
          value: "3",
        },
      ],
      signOutMiList: [
        {
          label: "100米",
          value: 100,
        },
        {
          label: "500米",
          value: 500,
        },
      ],
    };
  },
  async created() {
    await this.initSportTypes();
    await this.initSportSiteList();

    this.huodongID = this.$route.query.id || "";
    this.huodongxiangqing();
    this.huodongjiabin();
    this.huiguxiangqing();
    this.getAreaList();
  },
  methods: {
    /** 初始化活动类型*/
    async initSportTypes() {
      //  获取活动类型
      const resp = await getBusinessSportTypeList({
        limit: -1,
        token: sessionStorage.getItem("token"),
      });
      this.sportTypes = resp.data.data.map((item) => ({
        value: item.id,
        label: item.title,
      }));
      console.log("_this.sportTypes", this.sportTypes);
    },
    /** 初始化场地列表*/
    async initSportSiteList() {
      const resp = await getBusinessSportSiteList({
        limit: -1,
        token: sessionStorage.getItem("token"),
      });
      this.sportSites = resp.data.list.map((item) => ({
        value: item.id,
        label: item.title,
      }));
      console.log("_this.sportSites", this.sportSites);
    },
    handleAvatarSuccessLogo(response, file, fileList) {
      console.log("res", response);
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.addQuery.user_logo = response.pic_url;
        console.log(" this.addQuery.user_logo ", this.addQuery.user_logo);
      }
    },
    closeuserLogo() {
      this.addQuery.user_logo = "";
    },
    processDatecc() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.addQuery.enroll_starttime) {
            // 如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.addQuery.enroll_starttime).getTime() >
              time.getTime()
            );
          } else {
            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.addQuery.act_starttime) {
            // 如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.addQuery.act_starttime).getTime() > time.getTime()
            );
          } else {
            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    changeEnrolltime(values) {
      if (values) {
        this.addQuery.enroll_starttime = values[0];
        this.addQuery.enroll_endtime = values[1];
      } else {
        this.addQuery.enroll_starttime = "";
        this.addQuery.enroll_endtime = "";
      }
    },
    changeActtime(values) {
      if (values) {
        this.addQuery.act_starttime = values[0];
        this.addQuery.act_endtime = values[1];
      } else {
        this.addQuery.act_starttime = "";
        this.addQuery.act_endtime = "";
      }
    },
    inputIsNotSignin(value) {
      this.addQuery.signin_type = ["", "", ""];
    },
    clickSigninType(index) {
      this.$set(
        this.addQuery.signin_type,
        index,
        this.addQuery.signin_type[index] ? "" : this.signInList[index].value
      );
      this.isNotSignin = !this.addQuery.signin_type.find((item) => item);
    },
    inputIsNotSignout(value) {
      this.addQuery.signout_type = ["", "", ""];
    },
    clickSignoutType(index) {
      this.$set(
        this.addQuery.signout_type,
        index,
        this.addQuery.signout_type[index] ? "" : this.signOutList[index].value
      );
      this.isNotSignout = !this.addQuery.signout_type.find((item) => item);
    },
    changeSignintime(values) {
      if (values) {
        this.addQuery.signin_starttime = values[0];
        this.addQuery.signin_endtime = values[1];
      } else {
        this.addQuery.signin_starttime = "";
        this.addQuery.signin_endtime = "";
      }
    },
    onSuccessSignin_qrcode(response, file, fileList) {
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.addQuery.signin_qrcode = response.pic_url;
      }
    },
    changeSignouttime(values) {
      if (values) {
        this.addQuery.signout_starttime = values[0];
        this.addQuery.signout_endtime = values[1];
      } else {
        this.addQuery.signout_starttime = "";
        this.addQuery.signout_endtime = "";
      }
    },
    onSuccessSignout_qrcode(response, file, fileList) {
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.addQuery.signout_qrcode = response.pic_url;
      }
    },
    tijiaohuigu() {
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.huodongID,
        review: JSON.stringify(this.huiguQuery.review),
      };
      actSubmitreview(obj).then(({ data: res }) => {
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          setTimeout(() => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          }, 1000);
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          return false;
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: "2000",
          });
          this.huiguxiangqing();
        }
      });
    },
    huiguxiangqing() {
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.huodongID,
      };
      actReview(obj).then(({ data: res }) => {
        console.log("resccss", res);
        if (res.result === 1) {
          if (res.review) {
            this.huiguQuery.review = res.review;
          }
          //
        }
      });
    },
    Discountsearchcc() {
      this.huodongcur_page = 1;
      this.huodongjiabin();
      this.pageshowcc = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshowcc = true;
      });
    },
    handleSizeChangecc(val) {
      this.huodongQuery.pagesize = val;
    },
    handleCurrentChangecc(val) {
      this.huodongQuery.page = val;
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.huodongID,
        keyword: this.huodongQuery.keyword,
        page: this.huodongQuery.page,
        pagesize: this.huodongQuery.pagesize,
      };
      actEnrolllist(obj).then(({ data: res }) => {
        console.log("resss", res);
        this.huodongtableData = res.list;
        this.huodongTotal = res.total;
      });
    },
    huodongjiabin() {
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.huodongID,
        keyword: this.huodongQuery.keyword,
        page: this.huodongQuery.page,
        pagesize: this.huodongQuery.pagesize,
      };
      actEnrolllist(obj).then(({ data: res }) => {
        console.log("resss", res);
        this.huodongtableData = res.lisbt;
        this.huodongTotal = res.total;
      });
    },
    xiugaihuodong() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let signin_type = "0";
          if (!this.isNotSignin) {
            signin_type = this.addQuery.signin_type.join(",");
          }

          let signout_type = "0";
          if (!this.isNotSignout) {
            signout_type = this.addQuery.signout_type.join(",");
          }

          this.addQuery = {
            ...this.addQuery,
            sport_type: this.addQuery.sport_type.length
              ? this.addQuery.sport_type.join(",")
              : "",
            is_status: 1,
          };
          const obj = {
            ...this.addQuery,
            id: this.huodongID,
            token: sessionStorage.getItem("token"),
            pics: JSON.stringify(this.pics),
            act_sponsor: JSON.stringify(this.addQuery.act_sponsor),
            act_group_ids:
              this.addQuery.group_switch == 1
                ? this.activeGroup.map((item) => parseInt(item.id))
                : [],
            signin_type,
            signout_type,
          };
          actUpdate(obj).then(({ data: res }) => {
            console.log("res", res);
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              setTimeout(() => {
                window.sessionStorage.clear();
                this.$router.push("/login");
              }, 1000);
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              return false;
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: "success",
                duration: "2000",
              });
              this.huodongxiangqing();
            }
          });
        } else {
        }
      });
    },
    //  保存为草稿
    caogao() {
      this.$refs.form.clearValidate();
      let signin_type = "0";
      if (!this.isNotSignin) {
        signin_type = this.addQuery.signin_type.join(",");
      }

      let signout_type = "0";
      if (!this.isNotSignout) {
        signout_type = this.addQuery.signout_type.join(",");
      }

      this.addQuery = {
        ...this.addQuery,
        sport_type: this.addQuery.sport_type.length
          ? this.addQuery.sport_type.join(",")
          : "",
        is_status: 0,
      };

      const obj = {
        ...this.addQuery,
        id: this.huodongID,
        token: sessionStorage.getItem("token"),
        pics: JSON.stringify(this.pics),
        act_sponsor: JSON.stringify(this.addQuery.act_sponsor),
        act_group_ids:
          this.addQuery.group_switch == 1
            ? this.activeGroup.map((item) => parseInt(item.id))
            : [],
        signin_type,
        signout_type,
      };
      console.log("_草稿提交", obj);

      actUpdate(obj).then(({ data: res }) => {
        console.log("res", res);
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          setTimeout(() => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          }, 1000);
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          this.addQuery.sport_type = ""; //  重置类型选择
          return false;
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: "2000",
          });
          this.huodongxiangqing();
        }
      });
    },
    huodongxiangqing(options = {}) {
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.huodongID,
      };
      actview(obj).then(({ data: res }) => {
        // 修改分组, 重新获取
        if (options.changeKey && options.changeKey === "group_list") {
          this.activeGroup = res.group_list;
          return;
        }

        let areaArray = [res.area_id];
        if (res.town_id) {
          areaArray.push(res.town_id);
        }
        this.areaArray = areaArray;
        this.xiehuiQuery.org_com = res.org_com;
        this.xiehuiQuery.org_logo = res.org_logo;

        // console.log('_res.signin_type',res.signin_type)
        this.isNotSignin = res.signin_type.indexOf("0") > -1;
        if (this.isNotSignin) {
          res.signin_type = ["", "", ""];
        } else {
          res.signin_type = res.signin_type.toString().split(",");
        }

        // console.log('_res.signout_type',res.signout_type)
        this.isNotSignout = res.signout_type.indexOf("0") > -1;
        if (this.isNotSignout) {
          res.signout_type = ["", "", ""];
        } else {
          res.signout_type = res.signout_type.toString().split(",");
        }

        if (res.sport_type) {
          res.sport_type = res.sport_type
            .split(",")
            .map((item) => Math.floor(item));
        }

        // TIP: 2023年05月19日14:28:11 关闭限制编辑能力, 除了组别
        if (res.is_status === 0 || res.is_status === 1) {
          //  草稿和待审核阶段允许修改
        } else {
          // 其它阶段不允许修改
          // this.tempUpdateFlag = true; // 编辑能力标志
          this.groupFlag = true; //  组别 disable 标志
        }

        this.addQuery = res;
        this.activeGroup = res.group_list;
        console.log("_group_list", res.group_list);
        this.enrolltime = [res.enroll_starttime, res.enroll_endtime];
        this.acttime = [res.act_starttime, res.act_endtime];
        this.signintime = [res.signin_starttime, res.signin_endtime];
        this.signouttime = [res.signout_starttime, res.signout_endtime];

        this.pics = res.pics;
        this.addQuery.pics = this.pics;
        console.log("this.pics", this.pics);
        this.name = res.name;
      });
    },
    closeImgs(index) {
      console.log(index);
      this.pics.splice(index, 1);
      this.addQuery.pics = this.pics;
    },
    closeImgsreview(index) {
      this.huiguQuery.review.splice(index, 1);
    },
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.addQuery.enroll_starttime) {
            // 如果结束时间不为空，则小于结束时间
            return (
              new Date(self.addQuery.enroll_endtime).getTime() < time.getTime()
            );
          } else {
            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    addzanzucc() {
      this.addQuery.act_sponsor.push({
        name: "",
        content: "",
      });
    },
    Discountsearch() {
      this.cur_page = 1;
      this.List();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    select(selection, row) {
      if (selection.length > 1) {
        // eslint-disable-next-line camelcase
        const del_row = selection.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
      }
    },
    selectAll(selection) {
      if (selection.length > 1) {
        selection.length = 1;
      }
    },
    EdithandleSelectionChange(val) {
      console.log("val", val);
      this.xiehuiQuery = val[0];
      console.log("xiehuiQuery", this.xiehuiQuery);
    },
    handleSizeChange(val) {
      this.Querycc.pagesize = val;
    },
    handleCurrentChange(val) {
      this.Querycc.page = val;
      const obj = {};
      obj.pagesize = this.Querycc.pagesize;
      obj.page = this.Querycc.page;
      obj.keyword = this.Querycc.keyword;
      obj.token = this.Querycc.sessionStorage.getItem("token");
      actBusinessassociationlist(obj).then(({ data: res }) => {
        this.xiehuiArr = res.list;
        this.xiehuiTotal = res.total;
      });
    },
    List() {
      actBusinessassociationlist(this.Querycc).then(({ data: res }) => {
        console.log("rescc", res);
        this.xiehuiArr = res.list;
        this.xiehuiTotal = res.total;
      });
    },
    cclose() {
      this.$refs.fabuzhe.close();
    },
    openfabuzhe() {
      this.$refs.fabuzhe.open();
      this.List();
    },
    handleAvatar(response, file, fileList) {
      console.log("res", response);
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.huiguQuery.review.push({
          name: response.pic_url,
        });
        console.log(" this.huiguQuery.review ", this.huiguQuery.review);
      }
    },
    handleAvatarSuccess(response, file, fileList) {
      console.log("res", response);
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.pics.push({
          name: response.pic_url,
        });
        this.addQuery.pics = this.pics;
        console.log(" this.pics ", this.pics);
      }
    },
    beforeUpload(file) {
      console.log(file);
      const promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true);
        });
      });
      return promise; // 通过返回一个promis对象解决
    },
    progress(event, file, fileList) {
      console.log("event", event, "file", file, "fileList", fileList);
      // this.addquery.font_url.push({ name: file })
    },
    // 文件数量过多时提醒
    handleExceed() {
      // this.$message({ type: 'info', message: '最多支持5个附件上传' })
    },
    changList(val) {
      this.addQuery.area_id = val[0];
      this.addQuery.town_id = val[1] || "";
    },
    async lazyLoad(node, resolve) {
      const level = node.level;
      let result;
      let res;
      let param;
      switch (level) {
        case 0: // 一级
          res = await getWzArea();
          result = res.data.data;
          result.forEach((item) => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = item.code === "330300000000";
          });
          break;
        case 1: // 二级
          param = {
            code: node.data.code,
            pid: node.data.id,
          };
          res = await getWzArea(param);
          result = res.data.data;
          result.forEach((item) => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = level >= 1;
          });
          break;
        default:
          result = [];
          break;
      }
      resolve(result);
    },
    // EdithandleSelectionChange (val) {
    //   this.NewArr = []
    //   console.log('val', val)
    //   val.forEach(i => {
    //     this.NewArr.push(i.user_id)
    //     this.array = [...new Set(this.NewArr)]
    //     console.log('this.array', this.array)
    //   })
    // },
    addRow() {
      this.form.zanzu.push({});
    },
    del(index) {
      this.form.zanzu.splice(index, 1);
    },
    openAdd() {
      this.showDetails = true;
    },
    uploadSuccess(res, file) {
      this.$refs.upload_1.clearFiles();
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.result === 1) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        if (this.editorImgOrVideo === "img") {
          quill.insertEmbed(length, "image", res.pic_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          quill.insertEmbed(length, "video", res.video_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }

        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
    },
    uploadSuccess2(res, file) {
      this.$refs.upload_2.clearFiles();
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor2.quill;
      // 如果上传成功
      if (res.result === 1) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        if (this.editorImgOrVideo2 === "img") {
          quill.insertEmbed(length, "image", res.pic_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          quill.insertEmbed(length, "video", res.video_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }

        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
    },
    async getAreaList() {
      try {
        const res = await getWzArea();
        const result = res.data.data;
        result.forEach((item) => {
          item.value = item.code;
          item.label = item.name;
        });
        this.areaList = result;
      } catch (error) {
        console.log(error);
      }
    },
    GetJWD(type, signDistance, address, lng, lat) {
      if (this.tempUpdateFlag) return;
      this.mapShowType = type;
      this.$refs.AmapCom.initMap(type, signDistance, address, lng, lat);
    },
    AddrConfirm(res) {
      // console.log("onAddrConfirm", res);
      this.showMap = false;
      switch (this.mapShowType) {
        case "address":
          this.addQuery.longitude = res.lng;
          this.addQuery.latitude = res.lat;
          this.addQuery.address = res.address;
          this.addQuery.signin_distance = res.range; //  活动地址存储时, 默认保存签到地址和距离
          break;
        case "qiandao":
          this.addQuery.signin_lng = res.lng;
          this.addQuery.signin_lat = res.lat;
          this.addQuery.signin_address = res.address;
          this.addQuery.signin_distance = res.range;
          break;
        case "qiantui":
          this.addQuery.signout_lng = res.lng;
          this.addQuery.signout_lat = res.lat;
          this.addQuery.signout_address = res.address;
          this.addQuery.signout_distance = res.range;
          break;
        default:
          break;
      }
      this.addQuery.longitude = res.lng;
      this.addQuery.latitude = res.lat;
    },

    addGroup() {
      const act_id = this.huodongID;
      const activeGroupForm = this.activeGroupForm;
      if (activeGroupForm.ageStart && activeGroupForm.ageEnd) {
        // const nowYear = new Date().getFullYear();
        // const ageStart = nowYear - activeGroupForm.ageStart + 1;
        // const ageEnd = nowYear - activeGroupForm.ageEnd + 1;
        // activeGroupForm.age = ageStart + '到' + ageEnd;
        if (activeGroupForm.ageStart < activeGroupForm.ageEnd) {
          this.$message({
            message: "年龄选择有误",
            type: "error",
          });
          return;
        }
        activeGroupForm.age =
          activeGroupForm.ageStart + " - " + activeGroupForm.ageEnd;
      }
      if (
        activeGroupForm.name &&
        activeGroupForm.number &&
        activeGroupForm.age &&
        activeGroupForm.sex
      ) {
        const title =
          activeGroupForm.name +
          "," +
          activeGroupForm.number +
          "," +
          activeGroupForm.age +
          "," +
          activeGroupForm.sex;
        addActiveGroup({
          token: this.token,
          act_id,
          title,
        }).then(({ data: res }) => {
          this.activeGroupForm = {
            name: "",
            number: "",
            ageStart: "",
            ageEnd: "",
            age: "",
            sex: "不限",
          };

          this.huodongxiangqing({ changeKey: "group_list" });

          // this.activeGroup.push({
          //   act_id,
          //   id: res.data.id,
          //   title,
          //   ...activeGroupForm,
          // });
          // this.addQuery.act_group_ids = this.activeGroup.map((item) =>
          //   parseInt(item.id)
          // );
        });
      }
    },
    deleteGroup(item, index) {
      delActiveGroup({
        token: this.token,
        id: item.id,
      }).then((res) => {
        this.activeGroup.splice(index, 1);
        this.addQuery.act_group_ids = this.activeGroup.map((item) =>
          parseInt(item.id)
        );
      });
    },
  },
};
</script>

<style lang="less">
.amap-sug-result {
  z-index: 888888;
}

.ml {
  margin-left: 10px;
}

.addzanzu {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #3d9aff;
}

.from {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.imgbox {
  width: 188px;
  height: 188px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 5px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;

  .imgs {
    width: 100%;
    height: 100%;
  }

  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}

.radiobox {
  display: flex;
  flex-direction: row;
  align-items: center;

  .samnfa {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 10px;

    .imgs {
      width: 20px;
      height: 20px;
      opacity: 1;
      margin-right: 20px;
    }
  }
}

.el-upload-list {
  display: none;
}

.el-scrollbar__wrap {
  height: 200px;
}

.dsadf {
  color: #3d9aff;
}

.hearder {
  //width: 500px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .left {
    flex: 1;
  }
}

.boxssdff {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 11px;

  .addss {
    flex: 1;
  }
}

.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
  }

  .fromsss {
    margin-top: 54px;
  }
}

.block-none {
  display: none;
}
</style>
